// Search operator
// 1 - AND
// 2 - OR


export const defaultPayload = {
  
    "SearchCriteriaEquationDetails": {
        "SkillSearchDetails": {
            "AnySkillDetails": [],
            "AllSkillDetails": [],
            "ExcludeSkillDetails": [],
            "ValueExpression": "",
            "DisplayExpression": "",
            "SkillDetailsBoolOn": []
        }
    },
    "CustomFieldSearch": [],
    "SearchName": null,
    "JobOrderID": null,
    "IsJobOrderIDOptional": false,
    "JobOrderIDID": null,
    "JobOrderIDLabelKey": null,
    "CompanyName": null,
    "IsCompanyNameOptional": false,
    "CompanyNameID": null,
    "CompanyNameLabelKey": null,
    "ParentCompanySelectedValue": null,
    "ParentCompanySelectedText": null,
    "IsParentCompanyOptional": false,
    "ParentCompanyID": null,
    "ParentCompanyLabelKey": null,
    "PositionSelectedValue": null,
    "PositionSelectedText": null,
    "IsPositionOptional": false,
    "PositionID": null,
    "PositionLabelKey": null,
    "IsEmploymentTypeOptional": false,
    "EmploymentTypeSelectedValue": null,
    "EmploymentTypeSelectedText": null,
    "EmploymentTypeID": null,
    "EmploymentTypeLabelKey": null,
    "StatusSelectedValue": null,
    "StatusSelectedText": null,
    "IsStatusOptional": false,
    "StatusID": null,
    "StatusLabelKey": null,
    "Open": false,
    "OpenID": null,
    "OpenLabelKey": null,
    "IsOpenOptional": false,
    "IsCheckBoxOptional": false,
    "Filled": false,
    "FilledID": null,
    "FilledLabelKey": null,
    "IsFilledOptional": false,
    "Cancelled": false,
    "CancelledID": null,
    "CancelledLabelKey": null,
    "IsCancelledOptional": false,
    "IsStartDateOptional": false,
    "StartDateID": null,
    "StartDateLabelKey": null,
    "ConditionStartDate": null,
    "ConditionStartDateLabelKey": null,
    "IsEndDateOptional": false,
    "EndDateID": null,
    "EndDateLabelKey": null,
    "ConditionEndDate": null,
    "ConditionEndDateLabelKey": null,
    "IsExpiryDateOptional": false,
    "ExpiryDateID": null,
    "ExpiryDateLabelKey": null,
    "ConditionExpiryDate": null,
    "ConditionExpiryDateLabelKey": null,
    "IsReqIDOptional": false,
    "ReqID": null,
    "ReqIDID": null,
    "ReqIDLabelKey": null,
    "ReqStatusSelectedValue": null,
    "ReqStatusSelectedText": null,
    "IsReqStatusOptional": false,
    "ReqStatusID": null,
    "ReqStatusLabelKey": null,
    "IsMedTypeOptional": false,
    "MedType": null,
    "MedTypeID": null,
    "MedTypeLabelKey": null,
    "IsMedSpecialtyOptional": false,
    "MedSpecialty": null,
    "MedSpecialtyID": null,
    "MedSpecialtyLabelKey": null,
    "IsCostAllocationOptional": false,
    "CostAllocation": null,
    "CostAllocationID": null,
    "CostAllocationLabelKey": null,
    "DivisionSelectedValue": null,
    "DivisionSelectedText": null,
    "IsDivisionOptional": false,
    "DivisionID": null,
    "DivisionLabelKey": null,
    "DepartmentSelectedValue": null,
    "DepartmentSelectedText": null,
    "IsDepartmentOptional": false,
    "DepartmentID": null,
    "DepartmentLabelKey": null,
    "OfficeSelectedValue": null,
    "OfficeSelectedText": null,
    "IsOfficeOptional": false,
    "OfficeID": null,
    "OfficeLabelKey": null,
    "BusinessUnitSelectedValue": null,
    "BusinessUnitSelectedText": null,
    "IsBusinessUnitOptional": false,
    "BusinessUnitID": null,
    "BusinessUnitLabelKey": null,
    "AutoOwnerSelectedValue": null,
    "AutoOwnerSelectedText": null,
    "IsAutoOwnershipOptional": false,
    "AutoOwnershipID": null,
    "AutoOwnershipLabelKey": null,
    "AutoActMgrSelectedValue": null,
    "AutoActMgrSelectedText": null,
    "IsAutoActMgrOptional": false,
    "AutoActMgrID": null,
    "AutoActMgrLabelKey": null,
    "CustomUserList1Value": null,
    "CustomUserList1Text": null,
    "IsCustomUserList1Optional": false,
    "CustomUserList1ID": null,
    "CustomUserList1LabelKey": null,
    "CustomUserList2Value": null,
    "CustomUserList2Text": null,
    "IsCustomUserList2Optional": false,
    "CustomUserList2ID": null,
    "CustomUserList2LabelKey": null,
    "CustomUserList3Value": null,
    "CustomUserList3Text": null,
    "IsCustomUserList3Optional": false,
    "CustomUserList3ID": null,
    "CustomUserList3LabelKey": null,
    "AutoClassificationSelectedValue": null,
    "AutoClassificationSelectedText": null,
    "IsAutoClassificationOptional": false,
    "AutoClassificationID": null,
    "AutoClassificationLabelKey": null,
    "ScheduleActivitySelectedValue": null,
    "ScheduleActivitySelectedText": null,
    "IsScheduleActivityOptional": false,
    "ScheduleActivityID": "_listScheduleActivityId",
    "ScheduleActivityLabelKey": "4684",
    "WithScheduleActivity": true,
    "ScheduleStatusSelectedValue": null,
    "ScheduleStatusSelectedText": null,
    "IsScheduleStatusOptional": false,
    "ScheduleStatusID": "_listScheduleStatusId",
    "ScheduleStatusLabelKey": "4684",
    "EnteredDateFromID": "EnteredDateFromID",
    "EnteredDateToID": "EnteredDateToID",
    "EnteredDateLabelKey": null,
    "IsEnteredDateOptional": false,
    "StartDateScheduleFromID": "StartDateFromID",
    "StartDateScheduleToID": "StartDateToID",
    "StartDateScheduleLabelKey": null,
    "IsStartDateScheduleOptional": false,
    "IsContactsFirstNameOptional": false,
    "ContactsFirstName": null,
    "ContactsFirstNameID": null,
    "ContactsFirstNameLabelKey": null,
    "IsContactsLastNameOptional": false,
    "ContactsLastName": null,
    "ContactsLastNameID": null,
    "ContactsLastNameLabelKey": null,
    "IsJobFunctionOptional": false,
    "JobFunction": false,
    "JobFunctionID": null,
    "JobFunctionLabelKey": null,
    "IsJobRequirementOptional": false,
    "JobRequirement": false,
    "JobRequirementID": null,
    "JobRequirementLabelKey": null,
    "IsJobOrderProfileOptional": false,
    "JobOrderProfile": false,
    "JobOrderProfileID": null,
    "JobOrderProfileLabelKey": null,
    "IsNotesOptional": false,
    "Notes": false,
    "NotesID": null,
    "NotesLabelKey": null,
    "IsKeywordOptional": false,
    "Keyword": null,
    "KeywordID": null,
    "KeywordLabelKey": null,
    "CountrySelectedValue": null,
    "CountrySelectedText": null,
    "IsCountryOptional": false,
    "CountryID": null,
    "CountryLabelKey": null,
    "ProvinceStateSelectedValue": null,
    "ProvinceStateSelectedText": null,
    "IsProvinceStateOptional": false,
    "ProvinceStateID": null,
    "ProvinceStateLabelKey": null,
    "County": null,
    "IsCountyOptional": false,
    "CountyID": null,
    "CountyLabelKey": null,
    "ListCitiesValue": null,
    "ListCitiesID": "_listCities",
    "ListCitiesLabelKey": "9",
    "LkCitiesLabelKey": "9",
    "LkCitiesID": "_lkCities",
    "LkCitiesValue": null,
    "LkCitiesText": null,
    "IsCityOptional": false,
    "Address": null,
    "IsAddressOptional": false,
    "AddressID": null,
    "AddressLabelKey": null,
    "Address2": null,
    "IsAddress2Optional": false,
    "Address2ID": null,
    "Address2LabelKey": null,
    "ZipPostalCode": null,
    "IsZipPostalCodeOptional": false,
    "ZipPostalCodeID": null,
    "ZipPostalCodeLabelKey": null,
    "LocatedFrom": null,
    "LocatedFromID": null,
    "LocatedDistanceSelectedValue": null,
    "IsLocatedFromOptional": false,
    "NoteTypeSelectedValue": null,
    "NoteTypeSelectedText": null,
    "NoteTypeID": "_listNoteType",
    "NoteTypeLabelKey": "63",
    "IsNoteTypeOptional": false,
    "Id": 0,
    "Append": false
}



export const transformSearchData = (searchData, diffCheckPayload) => {
  const transformed = {
    filterElements: [],
    filterGroups: []
  };

  function isDifferent(obj1, obj2, key) {
    if (obj1[key] === obj2[key]) {
      return false;
    }
    if (typeof obj1[key] === 'object' && typeof obj2[key] === 'object') {
      return !Object.keys(obj1[key]).every(subKey => isDifferent(obj1[key], obj2[key], subKey));
    }
    return true;
  }

  function transformKey(key) {
    const keyMappings = {

      'CountriesSelectedText': 'Country',
      'PostalCode': 'ZipPostalCode',
      'ProvincesSelectedText': 'ProvinceState',
      'RatingSelectedText': 'Rating',
      'MarketSrcSelectedText': 'MarketingSource',
      'Ownership':'[Ownership]',
      'ClientCompany': 'CLI.companyname',
      'TotalCompensation':'CLI.TotalCompensation',
      'BaseSalaryID':'',
      'LastSalaryIncrease':'CLI.LastSalaryIncrease',
      'CandidateOfflimitData': 'CTE_CandidateOfflimitData',
      'LastContactedDateFrom': '',
      'LastContactedDateTo': '',
      'YearsExpFrom': 'YearsOfExperience',
      'YearsExpTo': 'YearsOfExperience',
      'BirthSelectedDate':'age',
      'OverTimePayRateFrom': 'OverTimePayRate',
      'OverTimePayRateTo': 'OverTimePayRate',
      'MinimumPayRateFrom': 'MinimumPayRate',
      'MinimumPayRateTo': 'MinimumPayRate',
      'OwnershipText': 'Ownership',
      'PhoneNumber': 'BusinessPhone',

      // Job Order mapping
      'JobOrderID' : 'JobID',
      'EmploymentTypeSelectedValue': '',
      'EmploymentTypeSelectedText': 'EmploymentType',
      'DivisionSelectedText': 'Division',
      'CompanyName': 'CompanyName',
      'PositionSelectedText': 'JobTitle',
      'StatusSelectedText': 'Status',
      'StartDate': '',
      'ConditionStartDate': '',
      'EndDate': '',
      'ConditionEndDate': '',
      'ReqID': 'ReqId',
      'ReqStatusSelectedText': 'ReqStatusId',
      'DepartmentSelectedText': 'Department',
      'OfficeSelectedText': 'Office',
      'BusinessUnitSelectedText': 'BusinessUnit',
      'AutoOwnerSelectedText': 'Ownership',
      'AutoActMgrSelectedText': 'AccountManager',
      'CustomUserList1Text': 'CustomUserList1',
      'CustomUserList2Text': 'CustomUserList2',
      'CustomUserList3Text': 'CustomUserList3',
      'CountrySelectedText': 'Country',
      'ListCitiesValue': 'City',
      'ProvinceStateSelectedText': 'ProvinceState',
      'Address': 'Location',
      'ZipPostalCode': 'PostalZip',
      'ContactsFirstName': 'JobOrder.Contact.ContactPerson.FirstName',
      'ContactsLastName': 'JobOrder.Contact.ContactPerson.LastName',
       
      // Client mapping
      'ClientID': 'ClientID',
      'WebAddress': 'WebAddress',
      'Email': 'DefaultEmail',
      'IndustryTypeSelectedText': 'IndustryType',
      'DiscountStructureSelectedText': 'DiscountStructure'

    };
    return keyMappings[key] || key;
  }

  const optionalGroupIds = {};
  const addedFields = new Set();

  const createFilterElement = (searchField, searchOperator, searchValue, groupId = null) => ({
    searchField,
    searchOperator,
    searchValue,
    ...(groupId !== null && { groupId })
  });



  Object.keys(searchData).forEach(key => {
    if (!isDifferent(searchData, diffCheckPayload, key)) {
      return;
    }
  
    // Skip adding ConditionAvailabilityRelation as a separate field
    if (key === "ConditionAvailiabilityRelation") {
      return;
    }
    if (key === "StatusSelectedValue") {
      return;
    }

    if (key === "ProvincesSelectedValue") {
      return;
    }

    if (key === "MarketSrcSelectedValue") {
      return;
    }


    if (key === "OwnershipValue") {
      return;
    }

    
  
    let operator = "="; // Default operator

    if (key === "LastContactedDateFrom") {
      operator = ">=";
    } else if (key === "LastContactedDateTo") {
      operator = "<=";
    }


    if (key === "YearsExpFrom") {
      operator = ">=";
    } else if (key === "YearsExpTo") {
      operator = "<=";
    }


    if (key === "OvertimePayRateFrom") {
      operator = ">=";
    } else if (key === "OvertimePayRateTo") {
      operator = "<=";
    }

    if (key === "MinimumPayRateFrom") {
      operator = ">=";
    } else if (key === "MinimumPayRateTo") {
      operator = "<=";
    }


    if (key === "ConditionBaseSalaryRelation") {
      if (searchData[key] === "=") {
        operator = "=";
      } else if (searchData[key] === ">") {
        operator = ">";
      } else if (searchData[key] === "<") {
        operator = "<";
      } else if (searchData[key] === ">=") {   
        operator = ">=";
      } else if (searchData[key] === "<=") {
        operator = "<=";
      } else if (searchData[key] === "!=") {
        operator = "!=";
      }    
    }
      


   if (key === 'KeyWordsearch') {
      const queryResult = createStructuredQuery({ KeyWordsearch: searchData[key] });
      if (queryResult) {
        transformed.filterElements.push(...queryResult.filterElements);
        transformed.filterGroups = queryResult.filterGroups;
      }
    } else if (key.startsWith('Is') && key.endsWith('Optional')) {
      console.log('process optional key here...');
      const baseKey = key.substring(2, key.length - 8);
      console.log(`Processing 'Is...Optional' key: ${key}, BaseKey: ${baseKey}`);
      if (baseKey in searchData) {
        const groupId = optionalGroupIds[baseKey] || (Object.keys(optionalGroupIds).length + 1);
        optionalGroupIds[baseKey] = groupId;
        console.log(`Assigned groupId ${groupId} to baseKey: ${baseKey}`);
        if (!transformed.filterGroups.some(group => group.groupId === groupId)) {
          transformed.filterGroups.push({
            groupId: groupId,
            groupOperator: 2, // OR operator
            parentGroupId: null
          });
          // console.log(`Added new group for groupId: ${groupId}`);
        }
      }
    } else if (key === "AvailabilityOn") {
      // Use the value from ConditionAvailabilityRelation as the operator for AvailabilityOn
      
      const availabilityOperator = searchData['ConditionAvailiabilityRelation'];
      console.log('key meets AvailabilityOn ', searchData)
      transformed.filterElements.push(createFilterElement("Candidate.AvailableDate", availabilityOperator, searchData[key]));
    } else if (!addedFields.has(key)) {
      const groupId = optionalGroupIds[key];
      console.log('optional group ids',  optionalGroupIds)
      console.log('optional group ids keys',  key)
      console.log('optional group ids request',  optionalGroupIds[key])
      console.log('optional group id',  groupId)
      if (groupId) {
        addedFields.add(key);
      }
      transformed.filterElements.push(createFilterElement(key, operator, searchData[key], groupId));
    }
  });

  console.log('Before setting keys:', transformed.filterElements);

  // Function to rename keys in the final step
  function renameKeys(filterElement) {
    return {
      ...filterElement,
      searchField: transformKey(filterElement.searchField)
    };
  }

  console.log('Before renaming keys:', transformed.filterElements);

 

  // Update filterElements with correct groupIds
  transformed.filterElements.forEach(element => {
    const originalKey = element.searchField.split('.')[1] || element.searchField;
    console.log('originalKey', originalKey)
    if (optionalGroupIds[originalKey]) {
      element.groupId = optionalGroupIds[originalKey];
      console.log(`Updated groupId for ${element.searchField} to ${element.groupId}`);
    }
  });

  console.log('Final transformed object:', transformed);

   // Apply the key renaming just before returning
   transformed.filterElements = transformed.filterElements.map(renameKeys);

  return transformed;
};





export const createStructuredQuery = (input) => {
  console.log("Input Received:", input.KeyWordsearch);
  const regex = /\(([^)]+)\) AND (\w+)/;
  const matches = input.KeyWordsearch.match(regex);

  if (!matches) {
    console.error('No matches found. Check the regular expression.');
    return null;
  }

  if (matches.length !== 3) {
    console.error('Unexpected number of matches. Expected 3 matches, found:', matches.length);
    return null;
  }

  // Extract terms from the matched groups
  const orTermsString = matches[1];
  const andTerm = matches[2];
  const orTerms = orTermsString.split(' or ');

  if (orTerms.length !== 2) {
    console.error('Invalid OR format. Expected two terms separated by " or "');
    return null;
  }

  const [term1, term2] = orTerms.map(term => term.trim());
  //console.log("Parsed Terms:", term1, term2, andTerm);

 
 
  const structuredQuery = {
    pageNumber: 1,
    pageSize: 20,
    filterElements: [
      {
        searchField: "KeyWordsearch", 
        searchOperator: "=",
        searchValue: term1,
        groupId: 1
      },
      {
        searchField: "KeyWordsearch",
        searchOperator: "=",
        searchValue: term2,
        groupId: 1
      },
      {
        searchField: "KeyWordsearch", 
        searchOperator: "=",
        searchValue: andTerm,
        groupId: 2
      }
    ],
    filterGroups: [
      {
        groupId: 1,
        groupOperator: 2, // OR operator
        parentGroupId: 3
      },
      {
        groupId: 2,
        groupOperator: 1, // AND operator, but single condition in this group
        parentGroupId: 3
      },
      {
        groupId: 3,
        groupOperator: 1, // AND operator for combining groups 1 and 2
        parentGroupId: null
      }
    ],
    logicalSearchOperator: 1 // Overall query logic
  };

  return structuredQuery;
}


export const demoMSSearchData = {
  "SearchCriteriaEquationDetails": {
      "SkillSearchDetails": {
          "AnySkillDetails": [],
          "AllSkillDetails": [],
          "ExcludeSkillDetails": [],
          "ValueExpression": "",
          "DisplayExpression": "",
          "SkillDetailsBoolOn": []
      }
  },
  "CustomFieldSearch": [],
  "SearchName": null,
  "JobOrderID": null,
  "IsJobOrderIDOptional": false,
  "JobOrderIDID": null,
  "JobOrderIDLabelKey": null,
  "CompanyName": null,
  "IsCompanyNameOptional": false,
  "CompanyNameID": null,
  "CompanyNameLabelKey": null,
  "ParentCompanySelectedValue": null,
  "ParentCompanySelectedText": null,
  "IsParentCompanyOptional": false,
  "ParentCompanyID": null,
  "ParentCompanyLabelKey": null,
  "PositionSelectedValue": null,
  "PositionSelectedText": null,
  "IsPositionOptional": false,
  "PositionID": null,
  "PositionLabelKey": null,
  "IsEmploymentTypeOptional": false,
  "EmploymentTypeSelectedValue": null,
  "EmploymentTypeSelectedText": null,
  "EmploymentTypeID": null,
  "EmploymentTypeLabelKey": null,
  "StatusSelectedValue": null,
  "StatusSelectedText": null,
  "IsStatusOptional": false,
  "StatusID": null,
  "StatusLabelKey": null,
  "Open": false,
  "OpenID": null,
  "OpenLabelKey": null,
  "IsOpenOptional": false,
  "IsCheckBoxOptional": false,
  "Filled": false,
  "FilledID": null,
  "FilledLabelKey": null,
  "IsFilledOptional": false,
  "Cancelled": false,
  "CancelledID": null,
  "CancelledLabelKey": null,
  "IsCancelledOptional": false,
  "IsStartDateOptional": false,
  "StartDateID": null,
  "StartDateLabelKey": null,
  "ConditionStartDate": null,
  "ConditionStartDateLabelKey": null,
  "IsEndDateOptional": false,
  "EndDateID": null,
  "EndDateLabelKey": null,
  "ConditionEndDate": null,
  "ConditionEndDateLabelKey": null,
  "IsExpiryDateOptional": false,
  "ExpiryDateID": null,
  "ExpiryDateLabelKey": null,
  "ConditionExpiryDate": null,
  "ConditionExpiryDateLabelKey": null,
  "IsReqIDOptional": false,
  "ReqID": null,
  "ReqIDID": null,
  "ReqIDLabelKey": null,
  "ReqStatusSelectedValue": null,
  "ReqStatusSelectedText": null,
  "IsReqStatusOptional": false,
  "ReqStatusID": null,
  "ReqStatusLabelKey": null,
  "IsMedTypeOptional": false,
  "MedType": null,
  "MedTypeID": null,
  "MedTypeLabelKey": null,
  "IsMedSpecialtyOptional": false,
  "MedSpecialty": null,
  "MedSpecialtyID": null,
  "MedSpecialtyLabelKey": null,
  "IsCostAllocationOptional": false,
  "CostAllocation": null,
  "CostAllocationID": null,
  "CostAllocationLabelKey": null,
  "DivisionSelectedValue": null,
  "DivisionSelectedText": null,
  "IsDivisionOptional": false,
  "DivisionID": null,
  "DivisionLabelKey": null,
  "DepartmentSelectedValue": null,
  "DepartmentSelectedText": null,
  "IsDepartmentOptional": false,
  "DepartmentID": null,
  "DepartmentLabelKey": null,
  "OfficeSelectedValue": null,
  "OfficeSelectedText": null,
  "IsOfficeOptional": false,
  "OfficeID": null,
  "OfficeLabelKey": null,
  "BusinessUnitSelectedValue": null,
  "BusinessUnitSelectedText": null,
  "IsBusinessUnitOptional": false,
  "BusinessUnitID": null,
  "BusinessUnitLabelKey": null,
  "AutoOwnerSelectedValue": null,
  "AutoOwnerSelectedText": null,
  "IsAutoOwnershipOptional": false,
  "AutoOwnershipID": null,
  "AutoOwnershipLabelKey": null,
  "AutoActMgrSelectedValue": null,
  "AutoActMgrSelectedText": null,
  "IsAutoActMgrOptional": false,
  "AutoActMgrID": null,
  "AutoActMgrLabelKey": null,
  "CustomUserList1Value": null,
  "CustomUserList1Text": null,
  "IsCustomUserList1Optional": false,
  "CustomUserList1ID": null,
  "CustomUserList1LabelKey": null,
  "CustomUserList2Value": null,
  "CustomUserList2Text": null,
  "IsCustomUserList2Optional": false,
  "CustomUserList2ID": null,
  "CustomUserList2LabelKey": null,
  "CustomUserList3Value": null,
  "CustomUserList3Text": null,
  "IsCustomUserList3Optional": false,
  "CustomUserList3ID": null,
  "CustomUserList3LabelKey": null,
  "AutoClassificationSelectedValue": null,
  "AutoClassificationSelectedText": null,
  "IsAutoClassificationOptional": false,
  "AutoClassificationID": null,
  "AutoClassificationLabelKey": null,
  "ScheduleActivitySelectedValue": null,
  "ScheduleActivitySelectedText": null,
  "IsScheduleActivityOptional": false,
  "ScheduleActivityID": "_listScheduleActivityId",
  "ScheduleActivityLabelKey": "4684",
  "WithScheduleActivity": true,
  "ScheduleStatusSelectedValue": null,
  "ScheduleStatusSelectedText": null,
  "IsScheduleStatusOptional": false,
  "ScheduleStatusID": "_listScheduleStatusId",
  "ScheduleStatusLabelKey": "4684",
  "EnteredDateFromID": "EnteredDateFromID",
  "EnteredDateToID": "EnteredDateToID",
  "EnteredDateLabelKey": null,
  "IsEnteredDateOptional": false,
  "StartDateScheduleFromID": "StartDateFromID",
  "StartDateScheduleToID": "StartDateToID",
  "StartDateScheduleLabelKey": null,
  "IsStartDateScheduleOptional": false,
  "IsContactsFirstNameOptional": false,
  "ContactsFirstName": null,
  "ContactsFirstNameID": null,
  "ContactsFirstNameLabelKey": null,
  "IsContactsLastNameOptional": false,
  "ContactsLastName": null,
  "ContactsLastNameID": null,
  "ContactsLastNameLabelKey": null,
  "IsJobFunctionOptional": false,
  "JobFunction": false,
  "JobFunctionID": null,
  "JobFunctionLabelKey": null,
  "IsJobRequirementOptional": false,
  "JobRequirement": false,
  "JobRequirementID": null,
  "JobRequirementLabelKey": null,
  "IsJobOrderProfileOptional": false,
  "JobOrderProfile": false,
  "JobOrderProfileID": null,
  "JobOrderProfileLabelKey": null,
  "IsNotesOptional": false,
  "Notes": false,
  "NotesID": null,
  "NotesLabelKey": null,
  "IsKeywordOptional": false,
  "Keyword": null,
  "KeywordID": null,
  "KeywordLabelKey": null,
  "CountrySelectedValue": null,
  "CountrySelectedText": null,
  "IsCountryOptional": false,
  "CountryID": null,
  "CountryLabelKey": null,
  "ProvinceStateSelectedValue": null,
  "ProvinceStateSelectedText": null,
  "IsProvinceStateOptional": false,
  "ProvinceStateID": null,
  "ProvinceStateLabelKey": null,
  "County": null,
  "City": "San Diego",
  "IsCountyOptional": false,
  "CountyID": null,
  "CountyLabelKey": null,
  "ListCitiesValue": null,
  "ListCitiesID": "_listCities",
  "ListCitiesLabelKey": "9",
  "LkCitiesLabelKey": "9",
  "LkCitiesID": "_lkCities",
  "LkCitiesValue": null,
  "LkCitiesText": null,
  "IsCityOptional": false,
  "Address": null,
  "IsAddressOptional": false,
  "AddressID": null,
  "AddressLabelKey": null,
  "Address2": null,
  "IsAddress2Optional": false,
  "Address2ID": null,
  "Address2LabelKey": null,
  "ZipPostalCode": null,
  "IsZipPostalCodeOptional": false,
  "ZipPostalCodeID": null,
  "ZipPostalCodeLabelKey": null,
  "LocatedFrom": null,
  "LocatedFromID": null,
  "LocatedDistanceSelectedValue": null,
  "IsLocatedFromOptional": false,
  "NoteTypeSelectedValue": null,
  "NoteTypeSelectedText": null,
  "NoteTypeID": "_listNoteType",
  "NoteTypeLabelKey": "63",
  "IsNoteTypeOptional": false,
  "Id": 0,
  "Append": false
}

//  export const demoMSSearchData = {
//   "SearchCriteriaEquationDetails": {
//       "SkillSearchDetails": {
//           "AnySkillDetails": [],
//           "AllSkillDetails": [],
//           "ExcludeSkillDetails": [],
//           "ValueExpression": "",
//           "DisplayExpression": "",
//           "SkillDetailsBoolOn": []
//       }
//   },
//   "CustomFieldSearch": [],
//   "SearchName": null,
//   "CandidateID": null,
//   "IsCandidateIDOptional": false,
//   "CandidateIdID": "_textCandidateId",
//   "CandidateIDLabelKey": "26",
//   "FirstName": "Linda",
//   "IsFirstNameOptional": true,
//   "FirstNameID": "_textFirstName",
//   "FirstNameLabelKey": "28",
//   "LastName": null,
//   "IsLastNameOptional": false,
//   "LastNameID": "_textLastName",
//   "LastNameLabelKey": "30",
//   "PhoneNumber": null,
//   "IsPhoneNumberOptional": false,
//   "PhoneNumberID": "_textPhone",
//   "PhoneNumberLabelKey": "21",
//   "PhoneType": null,
//   "PhoneTypeID": "_listPhoneType",
//   "PhoneTypeSelectedText": null,
//   "IsPhoneTypeOptional": false,
//   "Email": "gregory@redwerks.org",
//   "IsEmailOptional": false,
//   "EmailID": "_textEmail",
//   "EmailLabelKey": "1000",
//   "ExcludeCandidatesPartOfText": null,
//   "IsExcludeCandidatesPartOfOptional": false,
//   "ExcludeCandidatesPartOfID": "_autoExcludeCandidatesPartOf",
//   "ListExcludeCandidatesPartOf": null,
//   "CheckExcludeOfflimits": false,
//   "CheckBoxExcludeOfflimitsID": "_checkBoxExcludeOfflimits",
//   "IsDateAvailiabilityOptional": false,
//   "DateAvailiabilityID": "_dateAvailiability",
//   "ConditionAvailiabilityLabelKey": "1413",
//   "ConditionAvailiabilityRelation": null,
//   "IsDateLastContactedOptional": false,
//   "DateBoxLastContactID": "_dateBoxLastContact",
//   "ConditionLastContactLabelKey": "151",
//   "ConditionLastContactedRelation": null,
//   "IsMustHaveNotInPlaceOptional": false,
//   "DatePlaceFromID": "_datePlaceFrom",
//   "DatePlaceFromLabelKey": "1727",
//   "MustHaveNotInPlaceID": "_mustHaveNotInPlace",
//   "DatePlaceToID": "_datePlaceTo",
//   "ChkSun": false,
//   "ChkSunID": "_ckSun",
//   "LabelSun": "Sun",
//   "ChkMon": false,
//   "ChkMonID": "_ckMon",
//   "LabelMon": "Mon",
//   "ChkTue": false,
//   "ChkTueID": "_ckTue",
//   "LabelTue": "Tue",
//   "ChkWed": false,
//   "ChkWedID": "_ckWed",
//   "LabelWed": "Wed",
//   "ChkThu": false,
//   "ChkThuID": "_ckThu",
//   "LabelThu": "Thu",
//   "ChkFri": false,
//   "ChkFriID": "_ckFri",
//   "LabelFri": "Fri",
//   "ChkSat": false,
//   "ChkSatID": "_ckSat",
//   "LabelSat": "Sat",
//   "ScheduleActivitySelectedValue": null,
//   "ScheduleActivitySelectedText": null,
//   "IsScheduleActivityOptional": false,
//   "ScheduleActivityID": "_listScheduleActivityId",
//   "ScheduleActivityLabelKey": "4684",
//   "WithScheduleActivity": true,
//   "ScheduleStatusSelectedValue": null,
//   "ScheduleStatusSelectedText": null,
//   "IsScheduleStatusOptional": false,
//   "ScheduleStatusID": "_listScheduleStatusId",
//   "ScheduleStatusLabelKey": "4684",
//   "RecruiterSelectedValue": null,
//   "RecruiterSelectedText": null,
//   "RecruiterID": "_listRecruiterId",
//   "RecruiterLabelKey": "4684",
//   "IsRecruiterOptional": false,
//   "ResultOfActivitySelectedValue": null,
//   "ResultOfActivitySelectedText": null,
//   "ResultOfActivityID": "_listResultOfActivityId",
//   "ResultOfActivityLabelKey": "4684",
//   "IsResultOfActivityOptional": false,
//   "EnteredDateFromID": "EnteredDateFromID",
//   "EnteredDateToID": "EnteredDateToID",
//   "EnteredDateLabelKey": null,
//   "IsEnteredDateOptional": false,
//   "StartDateFromID": "StartDateFromID",
//   "StartDateToID": "StartDateToID",
//   "StartDateLabelKey": null,
//   "IsStartDateOptional": false,
//   "LastContactedDateFromID": "LastContactedDateFromID",
//   "LastContactedDateToID": "LastContactedDateToID",
//   "LastContactedDateLabelKey": null,
//   "IsLastContactedDateOptional": false,
//   "ChkOriginalResume": false,
//   "ChkOriginalResumeID": "_checkBoxOriginalResume",
//   "ChkModifiedResume": false,
//   "ChkModifiedResumeID": "_checkBoxModifiedResume",
//   "ChkHistoricalResume": false,
//   "ChkHistoricalResumeID": "_checkBoxHistoricalResume",
//   "ChkCandProfileNote": false,
//   "ChkCandProfileNoteID": "_checkBoxCandProfileNote",
//   "ChkNotes": true,
//   "ChkNotesID": "_checkBoxNotes",
//   "ChkEmail": false,
//   "ChkEmailID": "_checkBoxEmail",
//   "IsKeyWordSearch": false,
//   "KeyWordsearch": "(VP or \"vice president\") AND payroll",
//   "County": null,
//   "IsCountyOptional": false,
//   "CountyID": "_textCounty",
//   "CountyLabelKey": "4684",
//   "CountriesSelectedValue": null,
//   "CountriesSelectedText": null,
//   "CountryID": "_listCountries",
//   "CountriesLabelKey": "56",
//   "IsCountryOptional": false,
//   "ProvincesSelectedValue": null,
//   "ProvincesSelectedText": null,
//   "ProvincesID": "_listProvinces",
//   "ProvincesLabelKey": "55",
//   "IsProvincesOptional": false,
//   "ListCitiesValue": null,
//   "ListCitiesID": "_listCities",
//   "ListCitiesLabelKey": "9",
//   "LkCitiesLabelKey": "9",
//   "LkCitiesID": "_lkCities",
//   "LkCitiesValue": null,
//   "LkCitiesText": null,
//   "IsCityOptional": false,
//   "Address": null,
//   "AddressID": "_textAddress",
//   "AddressLabelKey": "8",
//   "IsAddressOptional": false,
//   "Address2": null,
//   "Address2ID": "_textAddress2",
//   "Address2LabelKey": "4004",
//   "IsAddress2Optional": false,
//   "PostalCode": null,
//   "PostalCodeID": "_textPostalCode",
//   "PostalCodeLabelKey": "10",
//   "IsPostalCodeOptional": false,
//   "LocatedFrom": null,
//   "LocatedFromID": "_textLocatedFrom",
//   "LocatedDistanceSelectedValue": null,
//   "IsLocatedFromOptional": false,
//   "BirthID": "_dateBirth",
//   "BirthLabelKey": "32",
//   "IsdateBirthOptional": false,
//   "AgeFrom": null,
//   "AgeFromID": "_txtAgeFrom",
//   "IsAgeOptional": false,
//   "AgeTo": null,
//   "AgeToID": "_txtAgeTo",
//   "YearsExpFrom": null,
//   "YearsExpFromID": "_txtYearsExpFrom",
//   "YearsExpTo": null,
//   "YearsExpToID": "_txtYearsExpTo",
//   "IsYearsExperienceOptional": false,
//   "TextSin": null,
//   "TextSinID": "_textSin",
//   "TextSinLabelKey": "128",
//   "IsSinIDOptional": false,
//   "StatusSelectedValue": null,
//   "StatusSelectedText": null,
//   "StatusID": "_listStatus",
//   "StatusLabelKey": "34",
//   "IsStatusOptional": false,
//   "SecondStatusSelectedValue": null,
//   "SecondStatusSelectedText": null,
//   "SecondStatusID": "_listSecondStatus",
//   "SecondStatusLabelKey": "4529",
//   "IsSecondStatusOptional": false,
//   "RatingSelectedValue": null,
//   "RatingSelectedText": null,
//   "RatingID": "_listRating",
//   "RatingLabelKey": "35",
//   "IsRatingOptional": false,
//   "MarketSrcSelectedValue": null,
//   "MarketSrcSelectedText": null,
//   "MarketSrcID": "_listMarketSrc",
//   "MarketSrcLabelKey": "1084",
//   "IsMarketSrcOptional": false,
//   "CandidateNpn": null,
//   "CandidateNpnID": "_txtCandidateNpn",
//   "CandidateNpnLabelKey": "4275",
//   "IsCandidateNpnOptional": false,
//   "TransportationTypeSelectedValue": null,
//   "TransportationTypeSelectedText": null,
//   "TransportationTypeID": "_listTransportation",
//   "TransportationTypeLabelKey": "3149",
//   "IsTransportationTypeOptional": false,
//   "EmploymentTypeSelectedValue": null,
//   "EmploymentTypeSelectedText": null,
//   "EmploymentTypeID": "_listEmploymentType",
//   "EmploymentTypeLabelKey": "117",
//   "IsEmploymentTypeOptional": false,
//   "PayRateCurrencySelectedValue": null,
//   "PayRateCurrencySelectedText": null,
//   "PayRateCurrencyID": "_listPayRateCurrency",
//   "PayRateCurrencyLabelKey": "5070",
//   "IsPayRateCurrencyOptional": false,
//   "MinimumPayRateFrom": null,
//   "MinimumPayRateFromID": "_txtMinimumPayRateFrom",
//   "MinimumPayRateFromLabelKey": "118",
//   "IsMinimumPayRateOptional": false,
//   "MinimumPayRateTo": null,
//   "MinimumPayRateToID": "_txtMinimumPayRateTo",
//   "OvertimePayRateFrom": null,
//   "OvertimePayRateFromID": "_txtOvertimePayRateFrom",
//   "OvertimePayRateFromLabelKey": "4982",
//   "IsOvertimePayRateOptional": false,
//   "OvertimePayRateTo": null,
//   "OvertimePayRateToID": "_txtOvertimePayRateTo",
//   "DivisionSelectedValue": null,
//   "DivisionSelectedText": null,
//   "DivisionID": "_listDivision",
//   "DivisionLabelKey": "143",
//   "IsDivisionOptional": false,
//   "DepartmentSelectedValue": null,
//   "DepartmentSelectedText": null,
//   "DepartmentID": "_listDepartment",
//   "DepartmentLabelKey": "146",
//   "IsDeptOptional": false,
//   "OfficeSelectedValue": null,
//   "OfficeSelectedText": null,
//   "OfficeID": "_listOffice",
//   "OfficeLabelKey": "1876",
//   "IsOfficeOptional": false,
//   "BusinessUnitSelectedValue": null,
//   "BusinessUnitSelectedText": null,
//   "BusinessUnitID": "_listBusinessUnit",
//   "BusinessUnitLabelKey": "556",
//   "IsBusinessUnitOptional": false,
//   "OwnershipValue": null,
//   "OwnershipText": null,
//   "OwnershipID": "_autoOwnership",
//   "OwnershipLabelKey": "1694",
//   "IsOwnershipOptional": false,
//   "CustomUserList1Value": null,
//   "CustomUserList1Text": null,
//   "CustomUserList1ID": "_listCustomUserList1",
//   "CustomUserList1LabelKey": "11414",
//   "IsCustomUserList1Optional": false,
//   "CustomUserList2Value": null,
//   "CustomUserList2Text": null,
//   "CustomUserList2ID": "_listCustomUserList2",
//   "CustomUserList2LabelKey": "11415",
//   "IsCustomUserList2Optional": false,
//   "CustomUserList3Value": null,
//   "CustomUserList3Text": null,
//   "CustomUserList3ID": "_listCustomUserList3",
//   "CustomUserList3LabelKey": "11416",
//   "IsCustomUserList3Optional": false,
//   "NoteTypeSelectedValue": "600",
//   "NoteTypeSelectedText": "Schedule",
//   "NoteTypeID": "_listNoteType",
//   "NoteTypeLabelKey": "63",
//   "IsNoteTypeOptional": false,
//   "ActMgrValue": null,
//   "ActMgrText": null,
//   "ActMgrID": "_autoActMgr",
//   "ActMgrLabelKey": "1818",
//   "IsActMgrOptional": false,
//   "CompanyName": null,
//   "CompanyNameID": "_txtCompanyName",
//   "CompanyNameLabelKey": "37",
//   "IsCompanyNameOptional": false,
//   "Title": null,
//   "TitleID": "_txtTitle",
//   "TitleLabelKey": "149",
//   "IsTitleOptional": false,
//   "BaseSalaryID": "_txtBaseSalary",
//   "ConditionBaseSalaryRelation": null,
//   "BaseSalaryLabelKey": null,
//   "IsBaseSalaryOptional": false,
//   "LastSalaryIncreaseID": "_txtLastSalaryIncrease",
//   "LastSalaryIncreaseLabelKey": "4952",
//   "IsLastSalaryIncreaseOptional": false,
//   "TotalCompensationID": "_txtTotalCompensation",
//   "TotalCompensationLabelKey": "4953",
//   "IsTotalCompensationOptional": false,
//   "ListID": 0,
//   "Append": false
// }